'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

function getUrlCacheIndex(url, mediaIdOrPath) {
    if (mediaIdOrPath === void 0) { mediaIdOrPath = null; }
    if (typeof url === 'string') {
        var inst = null;
        try {
            inst = new URL(url);
        }
        catch (e) {
            try {
                inst = new URL('http:://localhost/' + (url.indexOf('/') === 0 ? url.slice(1) : url));
            }
            catch (e) {
                // impossible to build URL
                return url;
            }
        }
        url = inst;
    }
    var path = url.pathname.lastIndexOf('/') === url.pathname.length - 1 ? url.pathname.slice(0, url.pathname.length - 1) : url.pathname;
    return "" + (mediaIdOrPath ? mediaIdOrPath + '/' : path) + url.search;
}

exports.getUrlCacheIndex = getUrlCacheIndex;
